export default {"src":"/_next/static/image/public/images/ic_location.66225791862a637a340d98d810b9cddf.svg","height":17,"width":15};